var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "automation-wizard-field-text" },
    [
      _c(
        "CompassFormItem",
        _vm._b(
          { attrs: { error: _vm.field.currentError || "" } },
          "CompassFormItem",
          _vm.formItemProps,
          false
        ),
        [
          _c("CompassInput", {
            attrs: {
              type: _vm.getType,
              menuClass: "automation-wizard-field-text"
            },
            model: {
              value: _vm.localValue,
              callback: function($$v) {
                _vm.localValue = $$v
              },
              expression: "localValue"
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }